import type {
  ReportingChartSpec,
  ReportingDataset,
} from 'src/queries/reportingAgent/reportingAgent.models'

export const LIVE_REPORTING_VERSION = 1 as const
export type LiveReportingVersion = typeof LIVE_REPORTING_VERSION

export interface LiveReportPinRequest {
  version: LiveReportingVersion
  candidate_id: string
  title: string
}

export interface LiveReportSummary {
  version: LiveReportingVersion
  id: string
  candidate_id: string
  title: string
  created_at: string
  updated_at: string
}

/** Detail metadata is intentionally the same public shape as a summary. */
export type LiveReportDetail = LiveReportSummary

export interface LiveReportSummaryPage {
  version: LiveReportingVersion
  items: LiveReportSummary[]
  next_cursor: string | null
}

export type LiveReportPage = LiveReportSummaryPage

export interface LiveReportResolvedRange {
  start: string
  end: string
}

export interface LiveReportResult {
  version: LiveReportingVersion
  report_id: string
  title: string
  chart_spec: ReportingChartSpec | null
  dataset: ReportingDataset
  resolved_range: LiveReportResolvedRange
  generated_at: string
  analysis_context_token: string
}
